export default "__VITE_ASSET__1e2da4bb__"